module.exports = __webpack_public_path__ + "img/224.33cffa91.gif";